import React, { useEffect, useState } from 'react';
import { getFirestore, collection, onSnapshot, query, where, orderBy } from "firebase/firestore";
import { Modal, Button } from 'react-bootstrap';
import './xDocList.css';

const XVideoz = () => {
    const [videos, setVideos] = useState([]);
    const [showLibrary, setShowLibrary] = useState(false);
    const db = getFirestore();

    useEffect(() => {
        const q = query(collection(db, "xVideoz"), where("status", "==", "active"), orderBy("createdAt", "desc"));
        return onSnapshot(q, (snap) => {
            setVideos(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        });
    }, [db]);

    const featured = videos.find(v => v.isFeatured === true) || videos[0];
    const others = videos.filter(v => v.id !== featured?.id);

    const getEmbed = (url) => {
        if (!url) return "";
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        const match = url.match(regExp);
        const videoId = (match && match[2].length === 11) ? match[2] : null;
        return videoId ? `https://www.youtube.com/embed/${videoId}?rel=0&enablejsapi=1` : "";
    };

    return (
        <div className="xVideoz-container mx-auto" style={{ maxWidth: '900px', position: 'relative', zIndex: 1 }}>
            {featured ? (
                <div className="featured-video-wrapper mb-4 ">
                    <div className="d-flex align-items-center justify-content-between mb-3 px-0">
                        <h4 className="xVideoz-main-title m-0 fw-bold orange">{featured.title}</h4>
                        {featured.isFeatured && <span className="badge-featured">FEATURED</span>}
                    </div>
                    <div className=" ratio ratio-16x9 rounded shadow-lg overflow-hidden border border-secondary border-opacity-25 bg-black" style={{ pointerEvents: 'auto' }}>
                        <iframe 
                            src={getEmbed(featured.fileUrl)} 
                            title={featured.title} 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                            allowFullScreen 
                            style={{ border: 0, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                        ></iframe>
                    </div>
                </div>
            ) : (
                <div className="text-center text-muted py-5 border border-secondary border-dashed rounded bg-dark bg-opacity-25">
                    <p className="m-0">Video library is currently empty.</p>
                </div>
            )}

            {others.length > 0 && (
                <Button variant="success" className="w-100 fw-bold py-2 mt-2" onClick={() => setShowLibrary(true)}>
                    Browse Club Library ({videos.length} Videos)
                </Button>
            )}

            <Modal show={showLibrary} onHide={() => setShowLibrary(false)} size="lg" centered contentClassName=" border-0">
                <div className="custom-admin-modal-body p-4" style={{ background: 'rgba(20,20,20,0.98)', borderRadius: '20px', border: '1px solid #444' }}>
                    <Modal.Header closeButton closeVariant="white" className="border-0">
                        <Modal.Title className="text-info fw-bold">Video Archive</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="admin-list-scroll" style={{ maxHeight: '70vh' }}>
                        <div className="row g-4">
                            {videos.map(vid => (
                                <div key={vid.id} className="col-md-6">
                                    <div className="video-card-transparent p-2">
                                        <div className="ratio ratio-16x9 mb-2 rounded overflow-hidden shadow-sm border border-secondary border-opacity-10 bg-black">
                                            <iframe src={getEmbed(vid.fileUrl)} title={vid.title} allowFullScreen style={{ border: 0 }}></iframe>
                                        </div>
                                        <span className="text-white fw-bold d-block text-truncate small px-1">{vid.title}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Modal.Body>
                </div>
            </Modal>
        </div>
    );
};

export default XVideoz;